export default {
  // Header
  "title": "Rastgele Pokemon Oluşturucu",
  "subtitle": "Tercihlerinize göre rastgele Pokemon karakterleri oluşturun",
  "home": "Ana Sayfa",
  "whichPokemonAmI": "Hangi Pokemon'um?",
  "aboutUs": "Hakkımızda",
  "contactUs": "İletişim",
  "privacyPolicy": "Gizlilik Politikası",
  
  // Filters
  "filterTitle": "Filtre Seçenekleri",
  "generateButton": "Rastgele Pokemon Oluştur",
  "generating": "Oluşturuluyor...",
  "numberOfPokemon": "Pokemon Sayısı",
  "type": "Tür",
  "generation": "Nesil",
  "minimumRarity": "Minimum Nadirlik (1-10)",
  "anyType": "Herhangi Tür",
  "anyGeneration": "Herhangi Nesil",
  "anyRarity": "Herhangi Bir Nadirlik",
  "countingPokemon": "Eşleşen Pokémon'lar sayılıyor",
  "matchingPokemonCount": "Filtrelerinizle eşleşen {{count}} Pokémon",
  "noPokemonToDisplay": "Gösterilecek Pokémon yok. Bazı Pokémon'lar oluşturun!",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Ateş",
  "water": "Su",
  "electric": "Elektrik",
  "grass": "Çim",
  "ice": "Buz",
  "fighting": "Dövüş",
  "poison": "Zehir",
  "ground": "Toprak",
  "flying": "Uçan",
  "psychic": "Psişik",
  "bug": "Böcek",
  "rock": "Kaya",
  "ghost": "Hayalet",
  "dragon": "Ejderha",
  "dark": "Karanlık",
  "steel": "Çelik",
  "fairy": "Peri",
  
  // Generations
  "Generation I": "1. Nesil",
  "Generation II": "2. Nesil",
  "Generation III": "3. Nesil",
  "Generation IV": "4. Nesil",
  "Generation V": "5. Nesil",
  "Generation VI": "6. Nesil",
  "Generation VII": "7. Nesil",
  "Generation VIII": "8. Nesil",
  "Generation IX": "9. Nesil",
  
  // Evolution Stage
  "evolutionStage": "Evrim Aşaması",
  "evolutionStageAll": "Tüm Aşamalar",
  "evolutionStageFullyEvolved": "Tamamen Evrimleşmiş",
  "evolutionStageNotFullyEvolved": "Tamamen Evrimleşmemiş",
  
  // About Section
  "aboutTitle": "Rastgele Pokemon Oluşturucu Hakkında",
  
  // Section titles
  "introTitle": "Rastgele Pokemon Oluşturucuya Hoş Geldiniz",
  "howToUseTitle": "Rastgele Pokemon Oluşturucu Nasıl Kullanılır",
  "benefitsTitle": "Rastgele Pokemon Oluşturucu Kullanmanın Faydaları",
  "historyTitle": "Pokemon Tarihi",
  "popularPokemonTitle": "Popüler Pokemon Karakterleri",
  "popularGamesTitle": "Popüler Pokemon Oyunları",
  "tradingContestsTitle": "Pokemon Takası ve Yarışmalar",
  "faqTitle": "Sık Sorulan Sorular",
  "conclusionTitle": "Pokemon ile Rastgele Maceranıza Bugün Başlayın!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokemon ve Pokemon karakter isimleri Nintendo'nun ticari markalarıdır.",
  "linksTitle": "Faydalı Bağlantılar",
  
  // About Us Page
  "aboutUsTitle": "Hakkımızda",
  "aboutUsWhoWeAre": "Biz Kimiz",
  "aboutUsWhoWeAreContent1": "Rastgele Pokemon Oluşturucu'ya hoş geldiniz, Pokemon tutkunları tarafından oluşturulmuş bir hayran yapımı araçtır. Yolculuğumuz 2023 yılında, kodlama ve Pokemon'u seven bir grup geliştirici topluluğa faydalı bir araç oluşturmaya karar verdiğinde başladı.",
  "aboutUsWhoWeAreContent2": "Ekibimiz, dünya çapındaki Pokemon hayranlarına en iyi deneyimi sunmak için birlikte çalışan geliştiriciler, tasarımcılar ve içerik oluşturuculardan oluşur.",
  "aboutUsOurMission": "Misyonumuz",
  "aboutUsOurMissionContent1": "Pokemon dünyasını herkes için daha erişilebilir ve eğlenceli hale getirmeyi amaçlıyoruz. Araçlarımız, eğitmenlerin yeni Pokemonları keşfetmelerine, dengeli takımlar oluşturmalarına ve mükemmel Pokemon'u bulmalarına yardımcı olmak için tasarlanmıştır.",
  "aboutUsOurMissionContent2": "Pokemon franchise'ına saygı duyarken topluma değer katan kullanımı kolay, doğru ve eğlenceli bir deneyim sunmaya kendimizi adadık.",
  "aboutUsOurTeam": "Ekibimiz",
  "aboutUsOurTeamContent1": "Çeşitli ekibimiz web geliştirme, Pokemon bilgisi, kullanıcı deneyimi tasarımı ve topluluk yönetimi konularında uzmanlıkları bir araya getirir. Pokemon sevgimiz ve yüksek kaliteli araçlar oluşturma taahhüdümüzle birleşiyoruz.",
  "aboutUsOurTeamContent2": "Ekibin her üyesi, Rastgele Pokemon Oluşturucu'yu olabildiğince iyi hale getirmek için benzersiz becerilerini ve bakış açılarını katar.",
  "aboutUsJoinUs": "Bize Katılın",
  "aboutUsJoinUsContent": "Her zaman topluluğumuza katılmak için hevesli kişiler arıyoruz. İster geliştirici, ister tasarımcı, ister Pokemon uzmanı veya hevesli bir kullanıcı olun, geri bildirimleriniz ve katkılarınız her zaman memnuniyetle karşılanır.",
  
  // Contact Us Page
  "contactUsTitle": "İletişim",
  "contactUsGetInTouch": "Bizimle İletişime Geçin",
  "contactUsGetInTouchContent": "Rastgele Pokemon Oluşturucu hakkında sorularınız, önerileriniz veya geri bildirimleriniz mi var? Sizden duymak isteriz! Ekibimizle nasıl iletişime geçebileceğiniz aşağıda belirtilmiştir.",
  "contactUsEmail": "E-posta",
  "contactUsPhone": "Telefon",
  "contactUsAddress": "Adres",
  "contactUsHelpSupport": "Yardım ve Destek",
  "contactUsHelpSupportContent": "Araçlarımızı kullanma konusunda yardıma mı ihtiyacınız var veya bir sorunla mı karşılaştınız? Destek ekibimiz yardıma hazır.",
  "contactUsFAQ": "SSS",
  "contactUsFAQContent": "Bizimle iletişime geçmeden önce, birçok yaygın soru ve sorunu kapsayan SSS bölümümüze göz atın.",
  "contactUsBugReport": "Hata Raporu",
  "contactUsBugReportContent": "Bir hata veya teknik sorun bulursanız, lütfen başlık satırında 'Hata Raporu' ile bize e-posta göndererek bizi bilgilendirin.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Gizlilik Politikası",
  "privacyPolicyIntro": "Giriş",
  "privacyPolicyIntroContent": "Rastgele Pokemon Oluşturucu'da, gizliliğinize saygı duyuyoruz ve kişisel verilerinizi korumayı taahhüt ediyoruz. Bu Gizlilik Politikası, web sitemizi kullandığınızda bilgilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.",
  "privacyPolicyInformation": "Topladığımız Bilgiler",
  "privacyPolicyInformationContent": "Hizmetlerimizi sağlamak ve iyileştirmek için minimal bilgi topluyoruz. Bu şunları içerebilir:",
  "privacyPolicyInformationItem1": "Kullanım verileri (ziyaret edilen sayfalar, sitede geçirilen süre, kullanılan özellikler gibi)",
  "privacyPolicyInformationItem2": "Cihaz bilgileri (tarayıcı türü, işletim sistemi, ekran çözünürlüğü)",
  "privacyPolicyInformationItem3": "IP adresi ve yaklaşık konum (yalnızca ülke düzeyinde)",
  "privacyPolicyCookies": "Çerezler ve Benzer Teknolojiler",
  "privacyPolicyCookiesContent": "Web sitemizdeki deneyiminizi geliştirmek için çerezler kullanıyoruz. Bu küçük metin dosyaları, tercihlerinizi hatırlamamıza ve site kullanımınızı analiz etmemize olanak tanır. Çerezleri tarayıcı ayarlarınızdan kontrol edebilirsiniz.",
  "privacyPolicyThirdParty": "Üçüncü Taraf Hizmetleri",
  "privacyPolicyThirdPartyContent": "Web sitemiz, analitik sağlayıcıları ve içerik dağıtım ağları gibi üçüncü taraf hizmetlerini kullanabilir. Bu hizmetler, web sitemizi kullanımınızla ilgili bilgileri toplayabilir. Tüm üçüncü tarafların gizliliğinize saygı duyduğunu ve verileri uygun şekilde işlediğini sağlıyoruz.",
  "privacyPolicySecurity": "Veri Güvenliği",
  "privacyPolicySecurityContent": "Bilgilerinizi yetkisiz erişim, değiştirme, ifşa veya imhaya karşı korumak için uygun güvenlik önlemleri uyguluyoruz. Ancak, internet üzerinden hiçbir aktarım %100 güvenli değildir, bu nedenle mutlak güvenliği garanti edemeyiz.",
  "privacyPolicyChanges": "Bu Politikadaki Değişiklikler",
  "privacyPolicyChangesContent": "Gizlilik Politikamızı zaman zaman güncelleyebiliriz. Yeni Gizlilik Politikasını bu sayfada yayınlayarak ve 'Son Güncelleme' tarihini güncelleyerek sizi herhangi bir değişiklik konusunda bilgilendireceğiz.",
  "privacyPolicyContact": "Bize Ulaşın",
  "privacyPolicyContactContent": "Bu Gizlilik Politikası hakkında herhangi bir sorunuz varsa, lütfen İletişim sayfasında sağlanan bilgiler aracılığıyla bizimle iletişime geçin.",
  "privacyPolicyLastUpdated": "Son Güncelleme",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Hangi Pokemon'um?",
  "whichPokemonAmISubtitle": "Sana en çok hangi Pokemon'un uyduğunu keşfet",
  "enterYourName": "Adınızı girin",
  "namePlaceholder": "Adınız",
  "enterFavoriteColor": "Favori renginizi seçin",
  "enterBirthMonth": "Doğum ayınızı seçin",
  "selectBirthMonth": "Ay seçin",
  "enterPersonalityTrait": "Kişilik özelliğinizi seçin",
  "selectPersonalityTrait": "Özellik seçin",
  "findMyPokemon": "Pokemon'umu bul",
  "calculating": "Hesaplanıyor...",
  "yourPokemonIs": "Senin Pokemon'un",
  "pokemonDescription": "Açıklama",
  "personalityMatch": "Kişilik Uyumu",
  "yourCompatibility": "Uyumluluğunuz",
  "downloadImage": "Resmi indir",
  "shareResult": "Sonucu paylaş",
  "tryAgain": "Tekrar dene",
  "results": "Sonuçlar",
  "aboutTool": "Bu Araç Hakkında",
  "howToUse": "Nasıl Kullanılır",
  "benefits": "Faydalar",
  "faq": "SSS",
  "conclusion": "Sonuç",
  
  // Error messages
  "nameRequired": "İsim gerekli",
  "colorRequired": "Lütfen bir renk seçin",
  "monthRequired": "Lütfen bir ay seçin",
  "traitRequired": "Lütfen bir kişilik özelliği seçin",
  
  // Months
  "january": "Ocak",
  "february": "Şubat",
  "march": "Mart",
  "april": "Nisan",
  "may": "Mayıs",
  "june": "Haziran",
  "july": "Temmuz",
  "august": "Ağustos",
  "september": "Eylül",
  "october": "Ekim",
  "november": "Kasım",
  "december": "Aralık",
  
  // Personality Traits
  "brave": "Cesur",
  "calm": "Sakin",
  "timid": "Ürkek",
  "jolly": "Neşeli",
  "quiet": "Sessiz",
  "hasty": "Aceleci",
  "careful": "Dikkatli",
  "lonely": "Yalnız",
  "bold": "Cesur",
  "relaxed": "Rahat",
  "impish": "Yaramaz",
  "modest": "Alçakgönüllü",
  
  // Additional translations for size matching feature
  "heightValid": "Lütfen geçerli bir boy girin (1-300 cm)",
  "weightValid": "Lütfen geçerli bir ağırlık girin (1-500 kg)",
  "enterDetails": "Detaylarınızı girin",
  "nameLabel": "İsim",
  "heightLabel": "Boy",
  "weightLabel": "Ağırlık",
  "finding": "Aranıyor...",
  "errorFinding": "Pokemon'unuzu bulurken hata oluştu",
  "matchResult": "{{name}} Pokemon'un...",
  "similarityScore": "Benzerlik puanı",
  "downloadStarted": "Resim hazırlanıyor...",
  "downloadComplete": "Resim başarıyla indirildi!",
  "shareText": "Ben {{pokemon}} olduğumu keşfettim! Sen hangi Pokemon'sun?",
  
  // Size matching feature
  "enterHeightWeight": "Boyunuzu ve kilonuzu girin — hangi Pokemon'un size uyduğunu görün!",
  "whichPokemonMatchesSize": "Hangi Pokemon sizin boyutunuza uyuyor?",
  "youAreMostLike": "En çok şuna benziyorsunuz",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Turkish)
  "pokemonRandomizerPageAboutTitle": "Nihai Pokémon Rastgeleleştirici Deneyimini Keşfedin",
  "pokemonRandomizer_whatIsItTitle": "Bir Pokémon Rastgeleleştirici Tam Olarak Nedir?",
  "pokemonRandomizer_featuresTitle": "Pokémon Rastgeleleştirici Aracımızın Temel Özellikleri",
  "pokemonRandomizer_whyUseTitle": "Neden Bir Pokémon Rastgeleleştirici ile Maceraya Atılmalı?",
  "pokemonRandomizer_gettingStartedTitle": "Başlarken: İlk Pokémon Rastgeleleştirici Turunuz",
  "pokemonRandomizer_faqTitle": "Pokémon Rastgeleleştirici: Sıkça Sorulan Sorular",
  "contact": "İletişim",
  "contactText": "Sorularınız veya önerileriniz mi var? Bize şuradan ulaşın:",
  "discordServer": "Discord Sunucusu",
  "twitter": "Twitter",
  "github": "GitHub",
  "buyMeACoffee": "Bana bir kahve ısmarla",
  "pokemonRandomizerPageH1": "Pokémon Rastgeleleştirici",
  "pokemonRandomizerPageSubtitle": "Pokémon neslinizi, türlerinizi ve daha fazlasını rastgeleleştirerek benzersiz Pokémon deneyimleri yaratın.",

  // Sub-Footer
  subFooterToolsTitle: "Araçlar",
  subFooterRandomPokemonGeneratorLink: "Rastgele Pokémon Oluşturucu",
  subFooterPokemonRandomizerLink: "Pokémon Rastgeleleştirici",
  subFooterWhichPokemonAmILink: "Hangi Pokémon'um?",

  subFooterPokemonDatabaseTitle: "Pokémon Veritabanı",
  subFooterPokedexLink: "Pokédex (Yakında)",
  subFooterTypeChartsLink: "Tür Tabloları (Yakında)",
  subFooterMoveListLink: "Hareket Listesi (Yakında)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "En Son Makaleler (Yakında)",
  subFooterGuidesTutorialsLink: "Kılavuzlar ve Öğreticiler (Yakında)"
};
